import { Action, ThunkAction } from "@reduxjs/toolkit"
import { StoreState } from "../store/StoreState"
import { NavigateFunction } from "react-router"
import { callApi } from "@/services/serverService"

export const loginThunk =
  (
    navigate: NavigateFunction,
    username: string,
    password: string
  ): ThunkAction<void, StoreState, null, Action> =>
  async (dispatch, getState) => {
    const res = await callApi<{ token: string; isAdmin: boolean }>("login", "post", {
      username,
      password,
    })
    if (res.token) {
      localStorage.setItem("jwt", JSON.stringify(res))
      navigate("/")
    } else {
      throw "Login failed"
    }
  }
